// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2179181e","735":"b7da1c73","782":"e9fac562","847":"c3481cb6"}[chunkId] + ".chunk.js";
};